import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SectionListComponent } from './modules/section-configuration/components/section-list/section-list.component';
import { WelcomeComponent } from './modules/home/components/welcome/welcome.component';
import { ManagementComponent } from './modules/management/components/management/management.component';
import { DeadLettersComponent } from './modules/dead-letters/components/dead-letters/dead-letters.component';

const routes: Routes = [
  {path: '', component: WelcomeComponent},
  {path: 'welcome', component: WelcomeComponent},
  {
    path: 'section-configuration', component: SectionListComponent
  },
  {
    path: 'management', component: ManagementComponent
  },
  {
    path: 'dead-letters', component: DeadLettersComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
